import { render, staticRenderFns } from "./SuperAdminAccordion.vue?vue&type=template&id=cf3bdbf0&scoped=true&"
import script from "./SuperAdminAccordion.vue?vue&type=script&lang=js&"
export * from "./SuperAdminAccordion.vue?vue&type=script&lang=js&"
import style0 from "./SuperAdminAccordion.vue?vue&type=style&index=0&id=cf3bdbf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3bdbf0",
  null
  
)

export default component.exports